import { values } from '@fortem-monorepo/js-utilities';
export const INVESTMENT_WRAPPER = {
    Eis: 'EIS - Taxed to CGT\n(under current rules)',
    Note: 'Note - Taxed to Income\n(under current rules)',
    CertificateEmtn: 'Certificate EMTN',
    Warrant: 'Warrant',
    NotApplicable: 'n/a',
};
export const INVESTMENT_WRAPPERS = values(INVESTMENT_WRAPPER);
